export const NAVBAR_MENU = [
  { title: "Home", name: "intro" },
  { title: "About", name: "about" },
  { title: "Work", name: "work" },
  { title: "Places", name: "places" },
];

export const TIMELINE_ELEMENTS = [
  {
    title: "Montreal, Quebec",
    time: "2004-2005",
    icon: "city",
  },
  {
    title: "Fushun, Liaoning",
    time: "2005",
    icon: "city",
  },
  {
    title: "Edmonton, Alberta",
    time: "2005-2006",
    icon: "city",
  },
  {
    title: "Katy, Texas",
    time: "2007-2008",
    icon: "city",
  },
  {
    title: "Fushun, Liaoning",
    time: "2008-2010",
    icon: "city",
  },
  {
    title: "Surrey, BC",
    time: "2010",
    icon: "city",
  },
  {
    title: "Rawlins, Wyoming",
    time: "2011-2012",
    icon: "town",
  },
  {
    title: "Laramie, Wyoming",
    time: "2012-2013",
    icon: "town",
  },
  {
    title: "Regina, Saskatchewan",
    time: "2014-2017",
    icon: "city",
  },
  {
    title: "Dawson Creek, BC",
    time: "2017-2019",
    icon: "town",
  },
  {
    title: "Grande Prairie, Alberta",
    time: "2019-2022",
    icon: "town",
  },
  {
    title: "Waterloo, Ontario",
    time: "2022-present",
    icon: "city",
  },
].reverse();

export const MAP_MARKERS = [
  {
    name: "Grande Prairie",
    coordinates: [-118.7885, 55.1707],
  },
  {
    markerOffset: -15,
    name: "Regina",
    coordinates: [-104.6189, 50.4452],
  },
  {
    name: "Laramie",
    coordinates: [-105.5911, 41.3114],
  },
  {
    name: "Surrey",
    coordinates: [-122.849, 49.1913],
  },
  {
    name: "Katy",
    coordinates: [-95.8245, 29.7858],
  },
  {
    markerOffset: -15,
    name: "Montreal",
    coordinates: [-73.5674, 45.5019],
  },
  {
    name: "Waterloo",
    coordinates: [-80.5204, 43.4643],
  },
  {
    name: "Edmonton",
    coordinates: [-113.4937, 53.5461],
  },
  {
    name: "Fushun",
    coordinates: [123.94363, 41.88669],
  },
  {
    name: "Rawlins",
    coordinates: [-107.2387, 41.7911],
  },
  {
    name: "Dawson Creek",
    coordinates: [-120.2377, 55.7596],
  },
];

export const WORK_INFORMATION = [
  {
    title: "Software Engineer Intern @Ramp",
    time: { start: "May 2025", end: "", isCurrent: true },
    desc: "TypeScript | React.js",
  },
  {
    title: "Software Engineer Intern (Design Systems) @Carta",
    time: { start: "Jan. 2025", end: "Apr. 2025", isCurrent: false },
    desc: "TypeScript | React.js",
  },
  {
    title: "Software Engineer Intern (Frontend Platform) @Carta",
    time: { start: "May 2024", end: "Aug. 2024", isCurrent: false },
    desc: "TypeScript | CircleCI | Docker | Python",
  },
  {
    title: "Frontend Engineer @Spade AI",
    time: { start: "Jan. 2024", end: "Feb. 2024", isCurrent: false },
    desc: "TypeScript | Next.js",
  },
  {
    title: "Full Stack Engineer @Ojje Inc.",
    time: { start: "Jun. 2023", end: "Sept. 2023", isCurrent: false },
    desc: "JavaScript | React.js",
  },
];
